import { forwardRef } from 'react';

import { Typography, TypographyProps } from '@material-ui/core';
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

const styles = () =>
  createStyles({
    root: {
      gridRow: '2',
    },
  });

export interface SidebarSectionDescriptionProps
  extends Omit<TypographyProps, 'classes'>,
    WithStyles<typeof styles> {}

const SidebarSectionDescriptionMui = forwardRef<
  HTMLElement,
  SidebarSectionDescriptionProps
>((props, ref) => {
  const { className, classes, children, ...rest } = props;

  return (
    <Typography
      ref={ref}
      variant="body2"
      color="textSecondary"
      className={classNames(className, classes.root)}
      {...rest}
    >
      {children}
    </Typography>
  );
});

SidebarSectionDescriptionMui.displayName = 'SidebarSectionMui.Description';

/** @deprecated Legacy MUI copy - migrate consumers to the Encore SidebarSection and delete. */
export default withStyles(styles)(SidebarSectionDescriptionMui);
